export default {
  confirmUpdate: 'Zapisać zmiany w tym przepisie?',
  recipeExists: 'Przepis istnieje',
  recipeName: 'Nazwa receptury',
};
